import "./StripeManageCardComponent.scss";
import {IComponentOptions, IOnChanges, IOnChangesObject, IScope} from "angular";
import {StripeCardSummary} from "../../types/TfStripeTypes";
import {ComponentCallback} from "../../../types/AngularJS";
import {AppUtil} from "../../../js/util/AppUtil";

export const StripeManage = "tfStripeManageCard";

export function stripeManage(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/manage/StripeManageCardComponent.html`,
        bindings: {
            card: "<",
            onChange: "&"
        },
        controllerAs: "ctrl",
        controller: StripeManageCardComponentController
    };
}

export class StripeManageCardComponentController implements IOnChanges {

    public card: StripeCardSummary | null;
    public onChange: ComponentCallback;

    public hideNewCardSection = true;

    /* Debounce is to stop any strange rendering that may happen from the $onChanges */
    public toggleNewCardSection: Function = AppUtil.debounce((hide?: boolean) => {
        if (hide == null) {
            this.hideNewCardSection = !this.hideNewCardSection;
        } else {
            this.hideNewCardSection = hide;
        }
        this.$scope.$applyAsync();
    }, 100);

    /** @ngInject */
    public constructor(private $scope: IScope) {

    }

    public $onChanges(changes: IOnChangesObject): void {
        this.toggleNewCardSection(this.card != null);
    }

    public cardAdded(card: StripeCardSummary) {
        this.hideNewCardSection = true;
        this.onChange({card});
    }
}
